import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import { withRouter } from 'react-router-dom'
import { openPopover } from '../../actions/popover'
import { routerReset } from '../../actions/router'
import { me, isPro } from '../../initial_state'
import { CX, MODAL_PRO_UPGRADE } from '../../constants'
import Button from '../button'
import Text from '../text'
import Icon from '../icon'
import SidebarSectionTitle from '../sidebar_section_title'
import SidebarSectionItem from '../sidebar_section_item'
import SidebarLayout from './sidebar_layout'
import { parse, format } from 'url'
import SimpleUserPanel from '../panel/simple_user_panel'
import { openModal } from '../../actions/modal'

function resizeUrl(avatar) {
  if (!avatar) return avatar
  const parts = parse(avatar)
  let pathname = parts.pathname
  if (pathname.indexOf('cdn-cgi') === -1) {
    //parts.pathname = `/cdn-cgi/image/width=30,quality=100,fit=scale-down${pathname}`
  }
  return format(parts)
}

const isHome = p => p === '/' || p === '/home'

class DefaultSidebar extends ImmutablePureComponent {

  state = {
    hoveringShortcuts: false,
    ctrlMeta: false
  }

  componentDidMount() {
    window.addEventListener('keyup', this.globalKeyup)
    window.addEventListener('keydown', this.globalKeydown)
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.globalKeyup)
    window.removeEventListener('keydown', this.globalKeydown)
  }

  handleOpenSidebarMorePopover = () => {
    this.props.openSidebarMorePopover({
      targetRef: this.moreBtnRef,
      position: 'top',
    })
  }

  handleMouseEnterShortcuts = () => {
    this.setState({ hoveringShortcuts: true })
  }

  handleMouseLeaveShortcuts = () => {
    this.setState({ hoveringShortcuts: false })
  }

  setMoreButtonRef = n => {
    this.moreBtnRef = n
  }

  globalKeydown = evt => {
    if (evt && (evt.ctrlKey || evt.metaKey) && this.state.ctrlMeta === false) {
      this.setState({ ctrlMeta: true })
    }
  }

  handleOnOpenProModal = () => {
    this.props.onOpenProModal('gs-s');
  }

  handleOnOpenProBusinessModal = () => {
    this.props.onOpenProBusinessModal('gs-s');
  }

  globalKeyup = evt => this.setState({ ctrlMeta: false })

  render() {
    const {
      notificationCount,
      homeItemsQueueCount,
      moreOpen,
      actions,
      tabs,
      title,
      showBackBtn,
      shortcuts,
      unreadChatsCount,
      routerEntries,
      location,
      history,
      sidebarChildren,
      button,
      search,
      page,
      slimLayout,
    } = this.props
    const { hoveringShortcuts, ctrlMeta } = this.state

    // const slimLayout = false
    // if (!me) return null

    const currentPathname = location.pathname
    let backTimes = 0
    let homeTo = '/home'
    let homeOnClick

    const isOnHome = isHome(currentPathname)

    if (!!sidebarChildren) {
      const isWide = page === 'business-create' || page === 'marketplace-listing-create'

      return (
        <SidebarLayout
          slimLayout={slimLayout}
          title={title}
          showBackBtn={showBackBtn}
          actions={actions}
          tabs={tabs}
          search={search}
          button={button}
          widthClass={isWide ? _s.sidebarWide : undefined}
        >
          {sidebarChildren}
        </SidebarLayout>
      )
    }
    
    let shortcutItems = []
    if (!!shortcuts) {
      shortcuts.forEach((s) => {
        let shortcutComponent = null
        if (s.get('shortcut_type') === 'list') {
          shortcutComponent = (
            <div className={[_s.d, _s.circle, _s.bgSecondary, _s.h30PX, _s.w30PX, _s.aiCenter, _s.jcCenter].join(' ')}>
              <Icon id='list' size='16px' className={_s.cSecondary} />
            </div>
          )
        } else if (s.get('shortcut_type') === 'tag') {
          shortcutComponent = (
            <div className={[_s.d, _s.circle, _s.bgSecondary, _s.h30PX, _s.w30PX, _s.aiCenter, _s.jcCenter].join(' ')}>
              <Text weight='medium' color='secondary'>#</Text>
            </div>
          )
        }

        const unreadCount = s.get('unread_count')
        let count = Math.min(unreadCount, 99)
        if (count === 99) count = '99+'

        shortcutItems.push({
          to: s.get('to'),
          title: s.get('title'),
          image: resizeUrl(s.get('image')),
          isGroup: ['group', 'business'].indexOf(s.get('shortcut_type')) > -1,
          count,
          shortcutComponent,
        })
      })
    }

    // find home in previous routes counting back how many times it is
    let homeFound = routerEntries.slice(1).some(function({ pathname }) {
      backTimes += 1
      return isHome(pathname)
    })

    if (
      isHome(currentPathname) === false &&
      homeFound &&
      backTimes > 0 &&
      history.length >= backTimes &&
      ctrlMeta === false // ctrl or meta means new tab
    ) {
      /*
      We've determined that there is an opportunity to go back to home and
      preserve the scroll Y position.
      */
      homeTo = undefined
      homeOnClick = () => {
        history.go(-backTimes)
        this.props.onRouterReset()
      }
    }

    if (isOnHome) {
      homeTo = undefined
      homeOnClick = () => {
        window.scroll(0,0)
      }
    }

    let notificationsTo = '/notifications'
    let notificationsOnClick = undefined
    if (currentPathname.startsWith('/notifications')) {
      notificationsTo = undefined
      notificationsOnClick = () => {
        window.scroll(0,0)
      }
    }

    let groupsTo = '/groups'
    let groupsOnClick = undefined
    if (currentPathname.startsWith('/groups') && !currentPathname.startsWith('/groups/')) {
      groupsTo = undefined
      groupsOnClick = () => {
        window.scroll(0,0)
      }
    }

    const spacerClasses = CX({
      d: 1,
      w100PC: 1,
      mb10: !!tabs && !isOnHome,
      mb5: !tabs,
    })

    return (
      <SidebarLayout
        slimLayout={slimLayout}
        title={isOnHome ? undefined : title}
        showBackBtn={showBackBtn}
        actions={actions}
        tabs={tabs}
        search={search}
        button={button}
      >
        {/* spacer */}
        { !isOnHome && <div className={spacerClasses} /> }

        { isOnHome && <SimpleUserPanel /> }
        { isOnHome && <div className={[_s.d, _s.h1PX, _s.w100PC, _s.bgSecondaryDark, _s.mb10].join(' ')} /> }

        <SidebarSectionItem title='Notifications' icon='notifications' to={notificationsTo} onClick={notificationsOnClick} count={notificationCount} slimLayout={slimLayout} />
        <SidebarSectionItem title='Suggestions' icon='group' to='/suggestions' slimLayout={slimLayout} />
        <SidebarSectionItem title='Explore' icon='explore' to='/explore' slimLayout={slimLayout} />
        <SidebarSectionItem title='Feeds' icon='list' to='/feeds?tab=own' slimLayout={slimLayout} />
        <SidebarSectionItem title='News' icon='news' to='/news' slimLayout={slimLayout} />
        <SidebarSectionItem title='Chats' icon='chat' to='/messages' count={unreadChatsCount} slimLayout={slimLayout} />
        <SidebarSectionItem title='See more' icon='more' onClick={this.handleOpenSidebarMorePopover} buttonRef={this.setMoreButtonRef} active={moreOpen} slimLayout={slimLayout} />

        {
          shortcutItems.length > 0 &&
          <>
            { isOnHome && <div className={[_s.d, _s.h1PX, _s.w100PC, _s.bgSecondaryDark, _s.mt10].join(' ')} /> }
            <SidebarSectionTitle>
              <div
                className={[_s.displayFlex, _s.aiCenter, _s.flexRow, _s.pr5].join(' ')}
                onMouseEnter={this.handleMouseEnterShortcuts}
                onMouseLeave={this.handleMouseLeaveShortcuts}
              >
                <span>Shortcuts</span>
                <Button
                  isText
                  to='/shortcuts'
                  color='brand'
                  backgroundColor='none'
                  className={_s.mlAuto}
                >
                  {
                    hoveringShortcuts &&
                    <Text color='inherit' weight='bold' align='right'>All</Text>
                  }
                </Button>
              </div>
            </SidebarSectionTitle>
            {
              shortcutItems.map((shortcutItem, i) => (
                <SidebarSectionItem slimLayout={slimLayout} {...shortcutItem} key={`sidebar-item-shortcut-${i}`} />
              ))
            }
          </>
        }

        { isOnHome && <div className={[_s.d, _s.h1PX, _s.w100PC, _s.bgSecondaryDark, _s.mt10].join(' ')} /> }

        <SidebarSectionTitle>More</SidebarSectionTitle>
        <SidebarSectionItem slimLayout={slimLayout} title='Gab AI' icon='ai-robot' href='https://gab.ai?f=gs-s' />
        <SidebarSectionItem slimLayout={slimLayout} title='Gab Shop' icon='shop' href='https://shop.dissenter.com' />
        {
          !!me && isPro && (
            <SidebarSectionItem slimLayout={slimLayout} title='Gab Voice' icon='audio' href='https://voice.gab.com/user/login' />
          )
        }
        <SidebarSectionItem slimLayout={slimLayout} title='Gab News' icon='news' href='https://news.gab.com' />
        <SidebarSectionItem slimLayout={slimLayout} title='Gab PRO' icon='pro' onClick={this.handleOnOpenProModal} />
        <SidebarSectionItem slimLayout={slimLayout} title='Gab PRO for Business' icon='pro' onClick={this.handleOnOpenProBusinessModal} />
        <SidebarSectionItem slimLayout={slimLayout} title='Gab Mobile App' icon='share' href='https://help.gab.com/article/gab-mobile-app' />
        <SidebarSectionItem slimLayout={slimLayout} title='Uncensored Image Generator' icon='ai-robot' href='https://gab.ai/start/gabby?f=gs-s' />
         
      </SidebarLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  shortcuts: state.getIn(['shortcuts', 'items']),
  moreOpen: state.getIn(['popover', 'popoverType']) === 'SIDEBAR_MORE',
  notificationCount: state.getIn(['notifications', 'unread']),
  unreadChatsCount: state.getIn(['chats', 'chatsUnreadCount']),
  homeItemsQueueCount: state.getIn(['timelines', 'home', 'totalQueuedItemsCount'], 0),
  routerEntries: state.getIn(['router', 'entries'], [])
})

const mapDispatchToProps = (dispatch) => ({
  openSidebarMorePopover(props) {
    dispatch(openPopover('SIDEBAR_MORE', props))
  },
  onRouterReset(){
    dispatch(routerReset())
  },
  onOpenProModal(subtitle) {
    dispatch(openModal(MODAL_PRO_UPGRADE, { subtitle }))
  },
  onOpenProBusinessModal(subtitle) {
    dispatch(openModal(MODAL_PRO_UPGRADE, { subtitle, isBusiness: true }))
  }
})

DefaultSidebar.propTypes = {
  moreOpen: PropTypes.bool,
  openSidebarMorePopover: PropTypes.func.isRequired,
  notificationCount: PropTypes.number.isRequired,
  homeItemsQueueCount: PropTypes.number.isRequired,
  unreadChatsCount: PropTypes.number.isRequired,
  actions: PropTypes.array,
  tabs: PropTypes.array,
  title: PropTypes.string,
  showBackBtn: PropTypes.bool,
  shortcuts: ImmutablePropTypes.list,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DefaultSidebar))
